import React, { PropsWithChildren } from 'react';
import LoadingOverlay from 'react-loading-overlay-ts';

export interface SpinnerProps {
  /**
   * Is the spinner active?
   */
  isLoading: boolean;
  /**
   * Optional hide text
   */
  hideText?: boolean;
  /**
   * Optional custom loading text
   */
  loadingText?: string;
  /**
   * Additional class names
   */
  className?: string;
}

export const Spinner: React.FC<PropsWithChildren<SpinnerProps>> = ({ children, ...props }) => {
  return (
    <LoadingOverlay
      styles={{
        wrapper: (base) => ({
          ...base,
        }),
        overlay: (base) => ({
          ...base,
          background: '#e9e9e9',
        }),
        content: (base) => ({
          ...base,
          color: '#6f777b',
          fontSize: 'smaller',
          fontFamily: 'Montserrat',
        }),
        spinner: (base) => ({
          ...base,
          width: '30px',
          margin: '0px auto 5px auto',
          '& svg circle': {
            stroke: '#00bec0',
          },
        }),
      }}
      className={props.className}
      active={props.isLoading}
      spinner
      text={!props.hideText && (props.loadingText || 'Please wait...')}>
      {children}
    </LoadingOverlay>
  );
};
